export function Error403({ size = 359 }) {
  const height = (251 * size) / 359;
  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 359 251"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17373_40845)">
        <rect width="359" height="251" rx="10" fill="#EDF6FF" />
        <rect x="-72" y="231.837" width="504.998" height="101" fill="#F7ECD2" />
        <rect x="114" y="29" width="132.465" height="202.837" fill="#E07696" />
        <rect
          x="118.141"
          y="33.1394"
          width="124.186"
          height="198.697"
          fill="url(#paint0_linear_17373_40845)"
        />
        <path
          d="M167.617 133.922L162.313 139.835C144.812 159.348 114.673 161.139 95.3423 143.815C114.673 161.139 116.172 191.279 98.6677 210.795L93.3639 216.708L98.6677 210.795C116.172 191.279 146.308 189.491 165.638 206.815C146.308 189.491 144.812 159.348 162.313 139.835L167.617 133.922Z"
          fill="#EAAF23"
        />
        <path
          d="M114.869 51.8112L115.509 56.1651C117.619 70.5322 107.705 84.0038 93.4778 86.0998C107.705 84.0038 121.074 94.043 123.185 108.412L123.824 112.766L123.185 108.412C121.074 94.043 130.988 80.5736 145.215 78.4776C130.988 80.5736 117.619 70.5322 115.509 56.1651L114.869 51.8112Z"
          fill="#EAAF23"
        />
        <path
          d="M124.371 23.4799C124.371 22.0053 125.648 20.8554 127.115 21.0098L242.324 33.1395V231.837L127.115 243.966C125.648 244.121 124.371 242.971 124.371 241.496V23.4799Z"
          fill="url(#paint1_linear_17373_40845)"
        />
        <path
          d="M83.0121 109.41L83.9219 111.432C86.9239 118.104 83.9745 125.999 77.3682 128.974C83.9745 125.999 91.8364 129.023 94.8388 135.696L95.7486 137.718L94.8388 135.696C91.8364 129.023 94.7862 121.129 101.393 118.154C94.7862 121.129 86.9239 118.104 83.9219 111.432L83.0121 109.41Z"
          fill="#EAAF23"
        />
        <ellipse cx="136.5" cy="135.5" rx="4.5" ry="6.5" fill="#F5F2EB" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_17373_40845"
          x1="139.252"
          y1="40.5905"
          x2="223.698"
          y2="161.465"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.25769" stopColor="#53438B" />
          <stop offset="1" stopColor="#604AAE" stopOpacity="0.48" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_17373_40845"
          x1="124"
          y1="132"
          x2="245.5"
          y2="132"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED5DA0" />
          <stop offset="0.956147" stopColor="#F188A8" />
          <stop offset="0.983539" stopColor="#DA4B76" />
        </linearGradient>
        <clipPath id="clip0_17373_40845">
          <rect width="359" height="251" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
